import produce from "immer";
import * as React from "react";
import { checkPassword } from "src/api";
import { Subscribe } from "unstated";
import FightContainer from "./FightContainer";
import FightPage from "./FightPage";
import FightPageLogin from "./FightPageLogin";

interface Props {
	match: { params: { fightId: number } };
	dark: boolean;
}
interface State {
	validPassword: boolean;
}

export default class FightPageContainer extends React.Component<Props, State> {
	private intervalId: number | undefined = undefined;
	public state = { validPassword: false };

	public async componentDidMount() {
		await this.checkAndSetHasValidPassword();
		this.intervalId = window.setInterval(() => {
			this.checkAndSetHasValidPassword();
		}, 5000);
	}

	public async componentWillUnmount() {
		clearInterval(this.intervalId);
	}

	private hasValidPassword = async (password: string | null) => {
		if (!password) {
			console.log("no valid password");
			return false;
		} else {
			const res = await checkPassword(this.props.match.params.fightId, password!);
			return res.success;
		}
	};

	public setJurorOrder = (jurorIDs: number[]) => {
		this.setState(
			produce((state) => {
				jurorIDs.forEach(
					(jurorID, position) => ((state as any).fight.jurors[jurorID].position = position)
				);
			})
		);
	};
	private async checkAndSetHasValidPassword() {
		const password = localStorage.getItem("sypt_fight_password");
		const validPassword = await this.hasValidPassword(password);
		if (!validPassword) {
			localStorage.setItem("sypt_fight_password", "");
			this.setState({ validPassword: false });
		}
		if (!this.state.validPassword) {
			this.setState({ validPassword });
		}
	}

	public render() {
		const { fightId } = this.props.match.params;
		if (this.state.validPassword) {
			return (
				<div>
					<Subscribe to={[FightContainer]}>
						{(container: FightContainer) => (
							<FightPage
								key={fightId}
								fightId={fightId}
								fightContainer={container}
								dark={this.props.dark}
							/>
						)}
					</Subscribe>
				</div>
			);
		} else {
			return (
				<div>
					<FightPageLogin
						onSuccessfulLogin={(res: any) => {
							localStorage.setItem("sypt_fight_password", res.password);
							this.setState({ validPassword: true });
						}}
						login={(password: string) => checkPassword(this.props.match.params.fightId, password)}
						title={"Fight " + this.props.match.params.fightId}
					/>
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/FightPageContainer.tsx